export default "__VITE_ASSET__4e548da0__"